export default "__VITE_ASSET__CS0sw6Sq__"